import Container from "@components/layout/Container";

const items = [
	{
		icon: "⬧",
		title: "Власне виробництво",
		desc: "Повний цикл від нарізки каменю до встановлення. Без посередників — ціни нижчі на 30%.",
	},
	{
		icon: "✦",
		title: "Натуральний камінь",
		desc: "Використовуємо тільки сертифікований камінь українського та імпортного виробництва.",
	},
	{
		icon: "◈",
		title: "Індивідуальний ескіз",
		desc: "Перед початком роботи ви побачите ескіз пам'ятника безкоштовно.",
	},
	{
		icon: "◇",
		title: "Гарантія 10 років",
		desc: "Офіційна гарантія на виріб з каменю. Безкоштовне усунення дефектів протягом гарантійного строку.",
	},
];

export default function WhyUs() {
	return (
		<section className="why-us">
			<Container>
				<header className="why-us-header">
					<span className="eyebrow-centered eyebrow-centered--on-light">
						Наші переваги
					</span>
					<h2 className="h2-serif">Чому обирають нас</h2>
				</header>

				<div className="why-us-grid">
					{items.map((it) => (
						<article key={it.title} className="why-card">
							<div className="why-card-icon">
								<span>{it.icon}</span>
							</div>
							<h3 className="why-card-title">{it.title}</h3>
							<p className="why-card-desc">{it.desc}</p>
						</article>
					))}
				</div>
			</Container>
		</section>
	);
}
